//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import AccountSvg from '~/assets/img/account.svg?inline'
import MenuSvg from '~/assets/img/bars-light.svg?inline'

export default {
  components: {
    AccountSvg,
    MenuSvg
  },

  data() {
    return {
      showBag: false,
      showNav: false
    }
  },

  computed: mapGetters('user', ['isSubscriber']),

  watch: {
    showBag(v) {
      if (v) {
        this.showNav = false
      }
    }
  },

  methods: {
    toggleMenu(nav) {
      if (this.showNav !== nav) {
        this.showNav = nav
      } else {
        this.showNav = false
      }
    }
  }
}
